import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, DatePicker, Select, TextInput } from 'components/Form'
import {
    // createApiOrderRecord,
    // updateApiOrderRecord,
    createApiRecord,
    updateApiRecord,
    uploadApiExtraDocuments,
} from 'services/SalesOrdersService'
import { useDispatch, useSelector } from 'react-redux'
import { getRecord, orderDefaultData } from './store/dataSlice'
import reducer from './store'
import { injectReducer } from 'store'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Success } from 'utils/alerts'
import { SimpleTable, Tabs, Upload } from 'components/Ui'
import { clone, remove } from 'lodash'
import dayjs from 'dayjs'
import { AiOutlineClose, AiOutlinePlus } from 'react-icons/ai'
import { priorityOptions, stateOptions } from 'utils/options'
injectReducer('salesOrders', reducer)

const validationSchema = Yup.object().shape({
    company: Yup.string().required('company field is required'),
    customer: Yup.string().required('customer field is required'),
    order_type: Yup.string().required('order type field is required'),
    warehouse_id: Yup.string().required('warehouse field is required'),
    doc_no: Yup.string().required('order no. field is required'),
    consignee_country: Yup.string().required('country field is required'),
    consignee_zip: Yup.string().required('post code field is required'),
    consignee_province: Yup.string().required('state field is required'),
    consignee_city: Yup.string().required('city field is required'),
    consignee_address1: Yup.string().required('address1 field is required'),
    consignee_name: Yup.string().required('name field is required'),
    consignee_mail: Yup.string().email('Invalid email format').nullable(),
})

const Create = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { companyData, productData, customersData, warehouseData, orderTypeData } = useSelector(state => state.listData)
    const { view, record, loading } = useSelector(state => state.salesOrders.data)

    useEffect(() => {
        if (id) {
            fetchData(id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const fetchData = id => {
        dispatch(getRecord(id))
    }

    const handleDiscard = () => navigate('/maestro/sales-orders')

    // const handleOrderDetails = data => {
    //     if (data?.id) {
    //         updateApiOrderRecord(data?.id, { ...data })
    //             .then(() => {})
    //             .catch(error => console.log('Error: ', error))
    //     } else {
    //         createApiOrderRecord({ ...data })
    //             .then(() => {})
    //             .catch(error => console.log('Error: ', error))
    //     }
    // }

    const uploadFile = (id, data) => {
        if (data?.file1 || data?.file2 || data?.file3 || data?.file4 || data?.file5) {
            uploadApiExtraDocuments(id, {
                file1: data?.file1 || '',
                file2: data?.file2 || '',
                file3: data?.file3 || '',
                file4: data?.file4 || '',
                file5: data?.file5 || '',
            })
                .then(() => {})
                .catch(error => console.log('Error: ', error))
        }
    }

    const handleSubmit = (data, setSubmitting) => {
        setSubmitting(true)
        const orderDetails = (data?.order_details ? data?.order_details : []).map(item => {
            // delete item?.sales_order
            // delete item?.id
            // delete item?.doc_no
            // delete item?.company
            // delete item?.is_deleted
            // delete item?.is_archive
            // delete item?.processing_batch_id
            // delete item?.import_batch_id
            // delete item?.processed_stamp
            // delete item?.error_message
            // delete item?.processed_timestamp
            // delete item?.source_system
            // delete item?.destination
            // delete item?.is_exported
            // delete item?.data_source
            // delete item?.created_at
            // delete item?.updated_at
            return {
                reference_no: item?.reference_no ? item?.reference_no : null,
                line_no: item?.line_no ? item?.line_no : null,
                sku: item?.sku ? item?.sku : null,
                qtyOrdered: item?.qty_ordered ? parseInt(item?.qty_ordered) : null,
                qty_ordered: item?.qty_ordered ? parseInt(item?.qty_ordered) : null,
                qty_shipped: item?.qty_shipped ? parseInt(item?.qty_shipped) : null,
                price: item?.price ? item?.price : null,
                lot_att01: item?.lot_att01 ? item?.lot_att01 : null,
                lot_att02: item?.lot_att02 ? item?.lot_att02 : null,
                lot_att03: item?.lot_att03 ? item?.lot_att03 : null,
                lot_att04: item?.lot_att04 ? item?.lot_att04 : null,
                lot_att05: item?.lot_att05 ? item?.lot_att05 : null,
                lot_att06: item?.lot_att06 ? item?.lot_att06 : null,
                lot_att07: item?.lot_att07 ? item?.lot_att07 : null,
                lot_att08: item?.lot_att08 ? item?.lot_att08 : null,
                lot_att09: item?.lot_att09 ? item?.lot_att09 : null,
                lot_att10: item?.lot_att10 ? item?.lot_att10 : null,
                lot_att11: item?.lot_att11 ? item?.lot_att11 : null,
                lot_att12: item?.lot_att12 ? item?.lot_att12 : null,
                lot_att13: item?.lot_att13 ? item?.lot_att13 : null,
                lot_att14: item?.lot_att14 ? item?.lot_att14 : null,
                lot_att15: item?.lot_att15 ? item?.lot_att15 : null,
                lot_att16: item?.lot_att16 ? item?.lot_att16 : null,
                lot_att17: item?.lot_att17 ? item?.lot_att17 : null,
                lot_att18: item?.lot_att18 ? item?.lot_att18 : null,
                lot_att19: item?.lot_att19 ? item?.lot_att19 : null,
                lot_att20: item?.lot_att20 ? item?.lot_att20 : null,
                lot_att21: item?.lot_att21 ? item?.lot_att21 : null,
                lot_att22: item?.lot_att22 ? item?.lot_att22 : null,
                lot_att23: item?.lot_att23 ? item?.lot_att23 : null,
                lot_att24: item?.lot_att24 ? item?.lot_att24 : null,
                dedi01: item?.dedi01 ? item?.dedi01 : null,
                dedi02: item?.dedi02 ? item?.dedi02 : null,
                dedi03: item?.dedi03 ? item?.dedi03 : null,
                dedi04: item?.dedi04 ? item?.dedi04 : null,
                dedi05: item?.dedi05 ? item?.dedi05 : null,
                dedi06: item?.dedi06 ? item?.dedi06 : null,
                dedi07: item?.dedi07 ? item?.dedi07 : null,
                dedi08: item?.dedi08 ? item?.dedi08 : null,
                dedi09: item?.dedi09 ? item?.dedi09 : null,
                dedi10: item?.dedi10 ? item?.dedi10 : null,
                dedi11: item?.dedi11 ? item?.dedi11 : null,
                dedi12: item?.dedi12 ? item?.dedi12 : null,
                dedi13: item?.dedi13 ? item?.dedi13 : null,
                dedi14: item?.dedi14 ? item?.dedi14 : null,
                dedi15: item?.dedi15 ? item?.dedi15 : null,
                dedi16: item?.dedi16 ? item?.dedi16 : null,
                user_define1: item?.user_define1 ? item?.user_define1 : null,
                user_define2: item?.user_define2 ? item?.user_define2 : null,
                user_define3: item?.user_define3 ? item?.user_define3 : null,
                user_define4: item?.user_define4 ? item?.user_define4 : null,
                user_define5: item?.user_define5 ? item?.user_define5 : null,
                user_define6: item?.user_define6 ? item?.user_define6 : null,
                user_define7: item?.user_define7 ? item?.user_define7 : null,
                user_define8: item?.user_define8 ? item?.user_define8 : null,
                user_define9: item?.user_define9 ? item?.user_define9 : null,
                user_define10: item?.user_define10 ? item?.user_define10 : null,
                notes: item?.notes ? item?.notes : null,
                archived_at: item?.archived_at ? item?.archived_at : null,
                processing_status: item?.processing_status ? item?.processing_status : null,
                processed_to_wms: item?.processed_to_wms ? item?.processed_to_wms : null,
                wms_processed_batch_id: item?.wms_processed_batch_id ? item?.wms_processed_batch_id : null,
                wms_processed_timestamp: item?.wms_processed_timestamp ? item?.wms_processed_timestamp : null,
            }
        })

        const datas = {
            warehouse_id: data?.warehouse_id ? data?.warehouse_id : null,
            order_type: data?.order_type ? data?.order_type : null,
            doc_no: data?.doc_no ? data?.doc_no : null,
            so_reference_a: data?.so_reference_a ? data?.so_reference_a : null,
            so_reference_b: data?.so_reference_b ? data?.so_reference_b : null,
            so_reference_c: data?.so_reference_c ? data?.so_reference_c : null,
            so_reference_d: data?.so_reference_d ? data?.so_reference_d : null,
            priority: data?.priority ? data?.priority : null,
            order_time: data?.order_time ? data?.order_time : null,
            expected_shipment_time1: data?.expected_shipment_time1 ? data?.expected_shipment_time1 : null,
            expected_shipment_time2: data?.expected_shipment_time2 ? data?.expected_shipment_time2 : null,
            required_delivery_time: data?.required_delivery_time ? data?.required_delivery_time : null,
            shipped_time: data?.shipped_time ? data?.shipped_time : null,
            delivery_no: data?.delivery_no ? data?.delivery_no : null,
            consignee_id: data?.consignee_id
                ? data?.consignee_id
                : data?.customer
                  ? customersData.find(item => item?.id.toString() === data?.customer?.toString())?.customer_code
                  : null,
            consignee_name: data?.consignee_name ? data?.consignee_name : null,
            consignee_address1: data?.consignee_address1 ? data?.consignee_address1 : null,
            consignee_address2: data?.consignee_address2 ? data?.consignee_address2 : null,
            consignee_address3: data?.consignee_address3 ? data?.consignee_address3 : null,
            consignee_contact: data?.consignee_contact ? data?.consignee_contact : null,
            consignee_country: data?.consignee_country ? data?.consignee_country : null,
            consignee_province: data?.consignee_province ? data?.consignee_province : null,
            consignee_city: data?.consignee_city ? data?.consignee_city : null,
            consignee_district: data?.consignee_district ? data?.consignee_district : null,
            consignee_street: data?.consignee_street ? data?.consignee_street : null,
            consignee_mail: data?.consignee_mail ? data?.consignee_mail : null,
            consignee_tel1: data?.consignee_tel1 ? data?.consignee_tel1 : null,
            consignee_tel2: data?.consignee_tel2 ? data?.consignee_tel2 : null,
            consignee_zip: data?.consignee_zip ? data?.consignee_zip : null,
            carrier_id: data?.carrier_id ? data?.carrier_id : null,
            carrier_name: data?.carrier_name ? data?.carrier_name : null,
            carrier_fax: data?.carrier_fax ? data?.carrier_fax : null,
            carrier_service: data?.carrier_service ? data?.carrier_service : null,
            carrier_mail: data?.carrier_mail ? data?.carrier_mail : null,
            channel: data?.channel ? data?.channel : null,
            hedi01: data?.hedi01 ? data?.hedi01 : null,
            hedi02: data?.hedi02 ? data?.hedi02 : null,
            hedi03: data?.hedi03 ? data?.hedi03 : null,
            hedi04: data?.hedi04 ? data?.hedi04 : null,
            hedi05: data?.hedi05 ? data?.hedi05 : null,
            hedi06: data?.hedi06 ? data?.hedi06 : null,
            hedi07: data?.hedi07 ? data?.hedi07 : null,
            hedi08: data?.hedi08 ? data?.hedi08 : null,
            hedi09: data?.hedi09 ? data?.hedi09 : null,
            hedi10: data?.hedi10 ? data?.hedi10 : null,
            invoice_print_flag: data?.invoice_print_flag ? data?.invoice_print_flag : null,
            route: data?.route ? data?.route : null,
            stop: data?.stop ? data?.stop : null,
            user_define1: data?.user_define1 ? data?.user_define1 : null,
            user_define2: data?.user_define2 ? data?.user_define2 : null,
            user_define3: data?.user_define3 ? data?.user_define3 : null,
            user_define4: data?.user_define4 ? data?.user_define4 : null,
            user_define5: data?.user_define5 ? data?.user_define5 : null,
            user_define6: data?.user_define6 ? data?.user_define6 : null,
            user_define7: data?.user_define7 ? data?.user_define7 : null,
            user_define8: data?.user_define8 ? data?.user_define8 : null,
            user_define9: data?.user_define9 ? data?.user_define9 : null,
            user_define10: data?.user_define10 ? data?.user_define10 : null,
            notes: data?.notes ? data?.notes : null,
            processed_to_wms: data?.processed_to_wms ? data?.processed_to_wms : null,
            wms_processed_batch_id: data?.wms_processed_batch_id ? data?.wms_processed_batch_id : null,
            wms_processed_timestamp: data?.wms_processed_timestamp ? data?.wms_processed_timestamp : null,
            company: data?.company ? data?.company : null,
            customer: data?.customer ? data?.customer : null,
            order_details: orderDetails ? orderDetails : [],
        }

        // delete data?.is_deleted
        // delete data?.is_archive
        // delete data?.processing_batch_id
        // delete data?.import_batch_id
        // delete data?.processed_stamp
        // delete data?.error_message
        // delete data?.processed_timestamp
        // delete data?.source_system
        // delete data?.destination
        // delete data?.is_exported
        // delete data?.data_source
        // delete data?.created_at
        // delete data?.updated_at

        if (id) {
            // data.hedi01 = data?.hedi01 || ''
            // data.hedi02 = data?.hedi02 || ''
            // data.hedi03 = data?.hedi03 || ''
            // data.hedi04 = data?.hedi04 || ''
            // data.hedi05 = data?.hedi05 || ''
            // data.hedi06 = data?.hedi06 || ''
            // data.hedi07 = data?.hedi07 || ''
            // data.hedi08 = data?.hedi08 || ''
            // data.route = data?.route || ''
            // data.notes = data?.notes || ''
            updateApiRecord(id, datas)
                .then(response => {
                    // data.order_details.map(item => {
                    //     handleOrderDetails({ ...item, sales_order: id })
                    //     return item
                    // })
                    setSubmitting(false)
                    Success('Updated Successfully!')
                    handleDiscard()
                    uploadFile(parseInt(id) + 1, data)
                })
                .catch(error => console.log('Error: ', error))
        } else {
            createApiRecord({ ...data, order_time: dayjs(new Date()).format('YYYY-MM-DDTHH:mm') })
                .then(response => {
                    // data.order_details.map(item => {
                    //     handleOrderDetails({ ...item, sales_order: response.data?.id })
                    //     return item
                    // })
                    Success('Created Successfully!')
                    setSubmitting(false)
                    handleDiscard()
                    uploadFile(response.data?.id, data)
                })
                .catch(error => console.log('Error: ', error))
        }
    }

    if (loading) {
        return null
    }

    return (
        <>
            <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">
                    {id ? 'Update Sales Order' : 'New Sales Order'}
                </h2>
            </div>
            <div className="flex flex-col items-center">
                <div className="w-full bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <div className="px-5 py-3 border-b border-stroke dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">
                            {id
                                ? 'Change delivery and product details to update a sales order'
                                : 'Enter delivery and product details to create a new sales order'}
                        </h3>
                    </div>
                    <div className="flex flex-col gap-3 p-6">
                        <Formik
                            initialValues={id ? record : view}
                            validationSchema={validationSchema}
                            onSubmit={(values, { setSubmitting }) => {
                                handleSubmit(values, setSubmitting)
                            }}
                        >
                            {({ values, isSubmitting, setFieldValue, touched, errors }) => (
                                <Form>
                                    <Tabs.Group version={1}>
                                        <Tabs.List>
                                            <Tabs>Order Header</Tabs>
                                            <Tabs>Customer Details</Tabs>
                                            <Tabs>Order Details</Tabs>
                                            {id && <Tabs>Additional Documents</Tabs>}
                                        </Tabs.List>
                                        <Tabs.Panels className="mt-4">
                                            <Tabs.Panel>
                                                <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-6">
                                                    <Field name="company">
                                                        {({ field, form }) => (
                                                            <Select
                                                                id="company"
                                                                name="company"
                                                                label="Company"
                                                                placeholder="Company"
                                                                className="md:col-span-2"
                                                                value={values?.company}
                                                                options={companyData}
                                                                onChange={e => {
                                                                    form.setFieldValue(field.name, e.target.value)
                                                                    form.setFieldValue('customer', '')
                                                                    form.setFieldValue('warehouse_id', '')
                                                                    form.setFieldValue('order_type', '')
                                                                }}
                                                                error={touched.company && errors.company}
                                                                message={errors.company}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="customer">
                                                        {({ field, form }) => (
                                                            <Select
                                                                options={customersData?.filter(
                                                                    item =>
                                                                        item?.company?.id?.toString() ===
                                                                        values?.company?.toString()
                                                                )}
                                                                label="Customer"
                                                                size="sm"
                                                                placeholder="Select"
                                                                name="customer"
                                                                className="md:col-span-2"
                                                                error={errors.customer && touched.customer}
                                                                message={errors.customer}
                                                                value={values?.customer}
                                                                onChange={e => {
                                                                    form.setFieldValue(field.name, e.target.value)
                                                                    form.setFieldValue('warehouse_id', '')
                                                                    form.setFieldValue('order_type', '')
                                                                }}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="warehouse_id">
                                                        {({ field, form }) => (
                                                            <Select
                                                                options={warehouseData
                                                                    ?.filter(
                                                                        item =>
                                                                            item?.company?.toString() ===
                                                                            values?.company?.toString()
                                                                    )
                                                                    ?.filter(
                                                                        item =>
                                                                            item?.customer?.toString() ===
                                                                            values?.customer?.toString()
                                                                    )}
                                                                label="Warehouse"
                                                                size="sm"
                                                                placeholder="Select"
                                                                className="md:col-span-2"
                                                                name="warehouse_id"
                                                                error={errors.warehouse_id && touched.warehouse_id}
                                                                message={errors.warehouse_id}
                                                                value={values?.warehouse_id}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="doc_no">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Order No"
                                                                name="doc_no"
                                                                error={errors.doc_no && touched.doc_no}
                                                                message={errors.doc_no}
                                                                value={values?.doc_no}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    {/* <Field name="order_type">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Order Type"
                                                                name="order_type"
                                                                error={errors.order_type && touched.order_type}
                                                                message={errors.order_type}
                                                                value={values?.order_type}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field> */}
                                                    <Field name="order_type">
                                                        {({ field, form }) => (
                                                            <Select
                                                                options={orderTypeData
                                                                    ?.filter(
                                                                        item =>
                                                                            item?.company?.toString() ===
                                                                            values?.company?.toString()
                                                                    )
                                                                    ?.filter(
                                                                        item =>
                                                                            item?.customer?.toString() ===
                                                                            values?.customer?.toString()
                                                                    )}
                                                                label="Order Type"
                                                                size="sm"
                                                                placeholder="Select"
                                                                className="md:col-span-2"
                                                                name="order_type"
                                                                error={errors.order_type && touched.order_type}
                                                                message={errors.order_type}
                                                                value={values?.order_type}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="so_reference_a">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Reference A"
                                                                name="so_reference_a"
                                                                error={errors.so_reference_a && touched.so_reference_a}
                                                                message={errors.so_reference_a}
                                                                value={values?.so_reference_a}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="so_reference_b">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Reference B"
                                                                name="so_reference_b"
                                                                error={errors.so_reference_b && touched.so_reference_b}
                                                                message={errors.so_reference_b}
                                                                value={values?.so_reference_b}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="so_reference_c">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Reference C"
                                                                name="so_reference_c"
                                                                error={errors.so_reference_c && touched.so_reference_c}
                                                                message={errors.so_reference_c}
                                                                value={values?.so_reference_c}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="priority">
                                                        {({ field, form }) => (
                                                            <Select
                                                                options={priorityOptions}
                                                                label="Priority"
                                                                size="sm"
                                                                placeholder="Select"
                                                                className="md:col-span-2"
                                                                name="priority"
                                                                error={errors.priority && touched.priority}
                                                                message={errors.priority}
                                                                value={values?.priority}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="carrier_name">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Carrier"
                                                                name="carrier_name"
                                                                error={errors.carrier_name && touched.carrier_name}
                                                                message={errors.carrier_name}
                                                                value={values?.carrier_name}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    {/* <Field name="carrier">
                                                        {({ field, form }) => (
                                                            <Select
                                                                options={carrierOptions}
                                                                label="Carrier"
                                                                size="sm"
                                                                placeholder="Select"
                                                                className="md:col-span-2"
                                                                name="carrier"
                                                                error={errors.carrier && touched.carrier}
                                                                message={errors.carrier}
                                                                value={values?.carrier}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field> */}
                                                    <Field name="expected_shipment_time1">
                                                        {({ field, form }) => (
                                                            <DatePicker
                                                                className="md:col-span-2"
                                                                label="Shipment Date"
                                                                name="expected_shipment_time1"
                                                                error={
                                                                    errors.expected_shipment_time1 &&
                                                                    touched.expected_shipment_time1
                                                                }
                                                                message={errors.expected_shipment_time1}
                                                                value={
                                                                    values?.expected_shipment_time1
                                                                        ? dayjs(values?.expected_shipment_time1).format(
                                                                              'YYYY-MM-DD'
                                                                          )
                                                                        : ''
                                                                }
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="required_delivery_time">
                                                        {({ field, form }) => (
                                                            <DatePicker
                                                                className="md:col-span-2"
                                                                label="Delivery Date"
                                                                name="required_delivery_time"
                                                                error={
                                                                    errors.required_delivery_time &&
                                                                    touched.required_delivery_time
                                                                }
                                                                message={errors.required_delivery_time}
                                                                value={
                                                                    values?.required_delivery_time
                                                                        ? dayjs(values?.required_delivery_time).format(
                                                                              'YYYY-MM-DD'
                                                                          )
                                                                        : ''
                                                                }
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                </div>
                                            </Tabs.Panel>
                                            <Tabs.Panel>
                                                <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-6">
                                                    <Field name="consignee_name">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Name"
                                                                name="consignee_name"
                                                                error={errors.consignee_name && touched.consignee_name}
                                                                message={errors.consignee_name}
                                                                value={values?.consignee_name}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="consignee_mail">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Email"
                                                                name="consignee_mail"
                                                                error={errors.consignee_mail && touched.consignee_mail}
                                                                message={errors.consignee_mail}
                                                                value={values?.consignee_mail}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="consignee_address1">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Address 1"
                                                                name="consignee_address1"
                                                                error={errors.consignee_address1 && touched.consignee_address1}
                                                                message={errors.consignee_address1}
                                                                value={values?.consignee_address1}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="consignee_address2">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Address 2"
                                                                name="consignee_address2"
                                                                error={errors.consignee_address2 && touched.consignee_address2}
                                                                message={errors.consignee_address2}
                                                                value={values?.consignee_address2}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="consignee_city">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="City"
                                                                name="consignee_city"
                                                                error={errors.consignee_city && touched.consignee_city}
                                                                message={errors.consignee_city}
                                                                value={values?.consignee_city}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="consignee_province">
                                                        {({ field, form }) => (
                                                            <Select
                                                                options={stateOptions}
                                                                label="State"
                                                                size="sm"
                                                                placeholder="Select"
                                                                className="md:col-span-2"
                                                                name="consignee_province"
                                                                error={errors.consignee_province && touched.consignee_province}
                                                                message={errors.consignee_province}
                                                                value={values?.consignee_province}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="consignee_zip">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Post Code"
                                                                name="consignee_zip"
                                                                error={errors.consignee_zip && touched.consignee_zip}
                                                                message={errors.consignee_zip}
                                                                value={values?.consignee_zip}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="consignee_country">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Country"
                                                                disabled
                                                                name="consignee_country"
                                                                error={errors.consignee_country && touched.consignee_country}
                                                                message={errors.consignee_country}
                                                                value={values?.consignee_country}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                </div>
                                            </Tabs.Panel>
                                            <Tabs.Panel>
                                                <div className="grid grid-cols-1 gap-x-4 gap-y-4">
                                                    {values?.order_details?.length ? (
                                                        <SimpleTable>
                                                            <thead>
                                                                <SimpleTable.TR>
                                                                    <SimpleTable.TH>Sequence</SimpleTable.TH>
                                                                    <SimpleTable.TH>Product</SimpleTable.TH>
                                                                    <SimpleTable.TH>Description</SimpleTable.TH>
                                                                    <SimpleTable.TH>Quantity</SimpleTable.TH>
                                                                    <SimpleTable.TH>Action</SimpleTable.TH>
                                                                </SimpleTable.TR>
                                                            </thead>
                                                            <tbody>
                                                                {(values?.order_details ?? []).map((item, index) => (
                                                                    <SimpleTable.TR key={`order-${index}`}>
                                                                        <SimpleTable.TD>{item?.line_no}</SimpleTable.TD>
                                                                        <SimpleTable.TD>
                                                                            {/* <Field name="sku">
                                                                                {({ field, form }) => (
                                                                                    <TextInput
                                                                                        type="text"
                                                                                        className="md:col-span-2"
                                                                                        placeholder="Product"
                                                                                        name="sku"
                                                                                        error={errors.sku && touched.sku}
                                                                                        message={errors.sku}
                                                                                        value={item?.sku}
                                                                                        onChange={e => {
                                                                                            form.setFieldValue(
                                                                                                `order_details[${index}].${field.name}`,
                                                                                                e.target.value
                                                                                            )
                                                                                            form.setFieldValue(
                                                                                                `order_details[${index}].line_no`,
                                                                                                index + 1
                                                                                            )
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </Field> */}
                                                                            <Field name="sku">
                                                                                {({ field, form }) => (
                                                                                    <Select
                                                                                        id="sku"
                                                                                        name="sku"
                                                                                        // label="Product"
                                                                                        placeholder="Product"
                                                                                        className="md:col-span-2"
                                                                                        value={item?.sku}
                                                                                        options={productData
                                                                                            ?.filter(
                                                                                                item =>
                                                                                                    item?.company?.toString() ===
                                                                                                    values?.company?.toString()
                                                                                            )
                                                                                            ?.filter(
                                                                                                item =>
                                                                                                    item?.customer?.toString() ===
                                                                                                    values?.customer?.toString()
                                                                                            )}
                                                                                        onChange={e => {
                                                                                            form.setFieldValue(
                                                                                                `order_details[${index}].${field.name}`,
                                                                                                e.target.value
                                                                                            )
                                                                                            form.setFieldValue(
                                                                                                `order_details[${index}].line_no`,
                                                                                                index + 1
                                                                                            )
                                                                                            form.setFieldValue(
                                                                                                `order_details[${index}].notes`,
                                                                                                productData?.find(
                                                                                                    item =>
                                                                                                        item?.sku ===
                                                                                                        e.target.value
                                                                                                )?.sku_descr1
                                                                                            )
                                                                                        }}
                                                                                        error={touched.sku && errors.sku}
                                                                                        message={errors.sku}
                                                                                    />
                                                                                )}
                                                                            </Field>
                                                                        </SimpleTable.TD>
                                                                        <SimpleTable.TD>
                                                                            {/* <Field name="notes">
                                                                                {({ field, form }) => (
                                                                                    <TextInput
                                                                                        type="text"
                                                                                        className="md:col-span-2"
                                                                                        placeholder="Description"
                                                                                        name="notes"
                                                                                        error={errors.notes && touched.notes}
                                                                                        message={errors.notes}
                                                                                        value={item?.notes}
                                                                                        onChange={e =>
                                                                                            form.setFieldValue(
                                                                                                `order_details[${index}].notes`,
                                                                                                e.target.value
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                )}
                                                                            </Field> */}
                                                                            {item?.notes}
                                                                        </SimpleTable.TD>
                                                                        <SimpleTable.TD>
                                                                            <Field name="qty_ordered">
                                                                                {({ field, form }) => (
                                                                                    <TextInput
                                                                                        type="text"
                                                                                        className="md:col-span-2"
                                                                                        placeholder="Quantity"
                                                                                        name="qty_ordered"
                                                                                        error={
                                                                                            errors.qty_ordered &&
                                                                                            touched.qty_ordered
                                                                                        }
                                                                                        message={errors.qty_ordered}
                                                                                        value={
                                                                                            item?.qty_ordered
                                                                                                ? parseInt(item?.qty_ordered)
                                                                                                : ''
                                                                                        }
                                                                                        onChange={e => {
                                                                                            if (
                                                                                                e.target.value === '' ||
                                                                                                /^[0-9]+$/.test(e.target.value)
                                                                                            ) {
                                                                                                form.setFieldValue(
                                                                                                    `order_details[${index}].${field.name}`,
                                                                                                    e.target.value
                                                                                                        ? parseInt(e.target.value)
                                                                                                        : ''
                                                                                                )
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </Field>
                                                                        </SimpleTable.TD>
                                                                        <SimpleTable.TD>
                                                                            <div className="flex items-center justify-center gap-3 py-1">
                                                                                {values?.order_details.length - 1 === index && (
                                                                                    <Button
                                                                                        type="button"
                                                                                        className="text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                                                                        onClick={() => {
                                                                                            const saveorder = clone(
                                                                                                values?.order_details ?? []
                                                                                            )
                                                                                            saveorder.push({
                                                                                                ...orderDefaultData,
                                                                                            })
                                                                                            setFieldValue(
                                                                                                'order_details',
                                                                                                saveorder
                                                                                            )
                                                                                        }}
                                                                                    >
                                                                                        <AiOutlinePlus size={20} />
                                                                                    </Button>
                                                                                )}
                                                                                <Button
                                                                                    type="button"
                                                                                    className="text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                                                                    onClick={() => {
                                                                                        const saveorder = clone(
                                                                                            values?.order_details
                                                                                        )
                                                                                        remove(
                                                                                            saveorder,
                                                                                            (n, key) => key === index
                                                                                        )
                                                                                        setFieldValue('order_details', saveorder)
                                                                                    }}
                                                                                >
                                                                                    <AiOutlineClose size={20} />
                                                                                </Button>
                                                                            </div>
                                                                        </SimpleTable.TD>
                                                                    </SimpleTable.TR>
                                                                ))}
                                                            </tbody>
                                                        </SimpleTable>
                                                    ) : (
                                                        <div className="flex items-center gap-3 py-1">
                                                            <Button
                                                                type="button"
                                                                className="text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                                                onClick={() => {
                                                                    const saveorder = clone(values?.order_details ?? [])
                                                                    saveorder.push({ ...orderDefaultData })
                                                                    setFieldValue('order_details', saveorder)
                                                                }}
                                                            >
                                                                <AiOutlinePlus size={20} />
                                                            </Button>
                                                        </div>
                                                    )}
                                                </div>
                                            </Tabs.Panel>
                                            <Tabs.Panel>
                                                <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-5">
                                                    <div>
                                                        <Field name="file1">
                                                            {({ field, form }) => (
                                                                <Upload
                                                                    onFilesSelected={files =>
                                                                        form.setFieldValue(field.name, files[0])
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                        {values?.file1 ? null : (
                                                            <div className="mt-4 text-[blue]">
                                                                {values?.hedi01 && (
                                                                    <a
                                                                        href={values?.hedi01 || '#'}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <u>Document - 1</u>
                                                                    </a>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <Field name="file2">
                                                            {({ field, form }) => (
                                                                <Upload
                                                                    onFilesSelected={files =>
                                                                        form.setFieldValue(field.name, files[0])
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                        {values?.file2 ? null : (
                                                            <div className="mt-4 text-[blue]">
                                                                {values?.hedi02 && (
                                                                    <a
                                                                        href={values?.hedi02 || '#'}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <u>Document - 2</u>
                                                                    </a>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <Field name="file3">
                                                            {({ field, form }) => (
                                                                <Upload
                                                                    onFilesSelected={files =>
                                                                        form.setFieldValue(field.name, files[0])
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                        {values?.file3 ? null : (
                                                            <div className="mt-4 text-[blue]">
                                                                {values?.hedi03 && (
                                                                    <a
                                                                        href={values?.hedi03 || '#'}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <u>Document - 3</u>
                                                                    </a>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <Field name="file4">
                                                            {({ field, form }) => (
                                                                <Upload
                                                                    onFilesSelected={files =>
                                                                        form.setFieldValue(field.name, files[0])
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                        {values?.file4 ? null : (
                                                            <div className="mt-4 text-[blue]">
                                                                {values?.hedi04 && (
                                                                    <a
                                                                        href={values?.hedi04 || '#'}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <u>Document - 4</u>
                                                                    </a>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <Field name="file5">
                                                            {({ field, form }) => (
                                                                <Upload
                                                                    onFilesSelected={files =>
                                                                        form.setFieldValue(field.name, files[0])
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                        {values?.file5 ? null : (
                                                            <div className="mt-4 text-[blue]">
                                                                {values?.hedi05 && (
                                                                    <a
                                                                        href={values?.hedi05 || '#'}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <u>Document - 5</u>
                                                                    </a>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </Tabs.Panel>
                                        </Tabs.Panels>
                                    </Tabs.Group>
                                    {values?.error_message && (
                                        <div className="mt-6 px-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
                                            <h4 className="text-sm text-[red] font-medium text-blue-900 dark:text-blue-100">
                                                Error: {values?.error_message}
                                            </h4>
                                        </div>
                                    )}
                                    <div
                                        className={`${!values?.error_message && 'mt-6'} p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg`}
                                    >
                                        <h4 className="text-sm font-medium text-blue-900 dark:text-blue-100 mb-2">
                                            Note: direct entry is limited to customers within Australia Only.
                                        </h4>
                                    </div>
                                    <div className="flex items-center justify-end gap-4 mt-3">
                                        <Button
                                            className="h-10 w-18 text-[#F05540] border border-[#F05540] dark:text-[#F05540] dark:border-[#F05540]"
                                            onClick={handleDiscard}
                                        >
                                            Discard
                                        </Button>
                                        <Button
                                            type="submit"
                                            disabled={isSubmitting}
                                            className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-[#F05540] bg-[#F05540] dark:border-[#F05540] dark:bg-[#F05540]"
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Create
